module.exports = __webpack_public_path__ + "img/framee28.309421f0.png";